import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from 'vue'
import { Calendars, Userspaces } from '@busy-human/opt-library'
import googleCalendar from '@/util/google-api';
import microsoftCalendar from '@/util/microsoft-graph';
import VLoader from "@/components/loader.vue";
import { useCalendars } from '@/store/calendars';

type Emits = {
    (e: 'close'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'calendar-overlay',
  emits: ["close"],
  setup(__props, { expose, emit }: { emit: ({
    (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {
  expose();



const loading = ref(false);
const microsoftMessage = ref('');

const calendars = useCalendars();

const microsoftActive = computed(() => !!calendars.calendars.find(cal => cal.type === 'microsoft' && cal.accessToken != ''))
const googleActive = computed(() => !!calendars.calendars.find(cal => cal.type === 'google' && cal.accessToken !== ''))

const microsoftEmail = computed(() => {
    const tmp = calendars.calendars.find(cal => cal.type === 'microsoft');
    if(tmp && tmp.type === 'microsoft') {
        return tmp.givenEmail || '';
    } else return ''
});
const googleMessage = ref('');

const doLinkGoogle = async () => {
    loading.value = true;
    googleMessage.value = '';
    const tmpWindow = window.open(undefined, "auth popup", "width=400,height=500,left=100,top=100");
    try{
        let result = await googleCalendar.linkGoogle(tmpWindow)
        if(result.success) {
            googleMessage.value = "Successfully linked to Google";
        } else {
            googleMessage.value = result.error;
        }
    }catch(e){
        console.warn("An Error Occurred while linking google")
    }finally{
        loading.value = false;
    }
}
const doUnlinkGoogle = async () => {
    loading.value = true;
    googleMessage.value = '';
    try {
        await googleCalendar.unlinkGoogle();
        googleMessage.value = "Successfully unlinked Google"
    } catch (e) {
        console.error(e);
        if(e instanceof Error) {
            googleMessage.value = e.message;
        } else {
            googleMessage.value = "Unable to unlink Google";
        }
    } finally {
        loading.value = false;
    }
}

const doLinkMicrosoft = async () => {
    loading.value = true;
    microsoftMessage.value = '';
    const tmpWindow = window.open(undefined, "auth popup", "width=400,height=500,left=100,top=100");
    try{
        let result = await microsoftCalendar.linkMicrosoft(tmpWindow)
        if(result.success) {
            microsoftMessage.value = "Successfully linked to Microsoft";
        } else {
            microsoftMessage.value = result.error;
        }
    }catch(e){
        console.warn("An Error Occurred while linking Microsoft")
    }finally{
        loading.value = false;
    }
}

const doUnlinkMicrosoft = async () => {
    loading.value = true;
    microsoftMessage.value = '';
    try {
        await microsoftCalendar.unlinkMicrosoft();
        microsoftMessage.value = "Successfully unlinked Microsoft"
    } catch (e) {
        console.error(e);
        if(e instanceof Error) {
            microsoftMessage.value = e.message;
        } else {
            microsoftMessage.value = "Unable to unlink Microsoft";
        }
    } finally {
        loading.value = false;
    }
}


const __returned__ = { emit, loading, microsoftMessage, calendars, microsoftActive, googleActive, microsoftEmail, googleMessage, doLinkGoogle, doUnlinkGoogle, doLinkMicrosoft, doUnlinkMicrosoft, ref, onMounted, computed, Calendars, Userspaces, googleCalendar, microsoftCalendar, VLoader, useCalendars }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})